module.exports = __webpack_public_path__ + "img/hr-tree-05-g-leaves.0f81eaa3.png";